import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import { DishFullInfoContext, IDishFullInfoContext } from '../../../../../../../dishFullInfoState/dishFullInfoContext';
import moment from 'moment';

const UpdatedField: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	const inputValue = dishForFullInfo?.updatedDate
		? `${moment(dishForFullInfo.updatedDate).format('MM/DD/YYYY h:mm:ss A')}   ${dishForFullInfo.updatedBy}`
		: undefined;

	return <FullInfoField label="lastUpdateLabel" value={inputValue} />;
};

export default UpdatedField;
